import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';
import Blogs from '../views/dashboards/Blogs';
import Blogs2 from '../views/dashboards/Blogs2';
/****Layouts*****/

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/

const Minimal = Loadable(lazy(() => import('../views/dashboards/Minimal')));
const Users = Loadable(lazy(() => import('../views/dashboards/Users')));
const Admin = Loadable(lazy(() => import('../views/dashboards/Admin')));
const Team = Loadable(lazy(() => import('../views/dashboards/Teams')));
const EditCluster = Loadable(lazy(() => import('../views/dashboards/EditCluster')));
const Cluster = Loadable(lazy(() => import('../views/dashboards/Cluster')));
const Feedback = Loadable(lazy(() => import('../views/dashboards/Feedback')));
const Company = Loadable(lazy(() => import('../views/dashboards/Company')));
const Analytical = Loadable(lazy(() => import('../views/dashboards/Analytical')));
const Demographical = Loadable(lazy(() => import('../views/dashboards/Demographical')));
const Modern = Loadable(lazy(() => import('../views/dashboards/Modern')));
const Analytics_Report = Loadable(lazy(() => import('../views/dashboards/Analytics_Report')));
const Coupon_Code = Loadable(lazy(() => import('../views/dashboards/Coupon_Code')));
const Banners = Loadable(lazy(() => import('../views/dashboards/Banners')));
const IssueCredits = Loadable(lazy(() => import('../views/dashboards/IssueCredits')));
const Group = Loadable(lazy(() => import('../views/dashboards/Groups')));
const CreateGroup = Loadable(lazy(() => import('../views/dashboards/CreateGroup')));
const CreateBanner = Loadable(lazy(() => import('../views/dashboards/CreateBanner')));
const UpdateBanner = Loadable(lazy(() => import('../views/dashboards/UpdateBanner')));
const CreateCoupon = Loadable(lazy(() => import('../views/dashboards/CreateCoupon')));
const CreatePromoCode = Loadable(lazy(() => import('../views/dashboards/CreatePromoCode')));
const Interview = Loadable(lazy(() => import('../views/dashboards/interview')));
const JobPost = Loadable(lazy(() => import('../views/dashboards/jobs')));
const NewJobPost = Loadable(lazy(() => import('../views/dashboards/NewJobPost')));
const NewCompany = Loadable(lazy(() => import('../views/dashboards/NewCompany')));
const ListingCompanies = Loadable(lazy(() => import('../views/dashboards/ListingCompanies')));
const CompanyRegister = Loadable(lazy(() => import('../views/dashboards/Register')));
const Events = Loadable(lazy(() => import('../views/dashboards/Events')));

const NewBlogs = Loadable(lazy(() => import('../views/blogs/Blogs')));
const NewCreateBlog = Loadable(lazy(() => import('../views/blogs/CreateBlog')));
const NewUpdateBlog = Loadable(lazy(() => import('../views/blogs/UpdateBlog')));
const ViewBlog = Loadable(lazy(() => import('../views/blogs/ViewBlog')));

/***** Apps ****/
const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')));
const Chat = Loadable(lazy(() => import('../views/apps/chat/Chat')));
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')));
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/CalendarApp')));
const Email = Loadable(lazy(() => import('../views/apps/email/Email')));
const Shop = Loadable(lazy(() => import('../views/apps/ecommerce/Shop')));
const ShopDetail = Loadable(lazy(() => import('../views/apps/ecommerce/ShopDetail')));
const Treeview = Loadable(lazy(() => import('../views/apps/treeview/TreeView')));
const TicketList = Loadable(lazy(() => import('../views/apps/ticket/TicketList')));
const TicketDetail = Loadable(lazy(() => import('../views/apps/ticket/TicketDetail')));

/***** Ui Elements ****/
const Alerts = Loadable(lazy(() => import('../views/ui/Alerts')));
const Badges = Loadable(lazy(() => import('../views/ui/Badges')));
const Buttons = Loadable(lazy(() => import('../views/ui/Buttons')));
const Cards = Loadable(lazy(() => import('../views/ui/Cards')));
const Grid = Loadable(lazy(() => import('../views/ui/Grid')));
const Tables = Loadable(lazy(() => import('../views/ui/Tables')));
const Forms = Loadable(lazy(() => import('../views/ui/Forms')));
const Breadcrumbs = Loadable(lazy(() => import('../views/ui/Breadcrumbs')));
const Dropdowns = Loadable(lazy(() => import('../views/ui/DropDown')));
const BtnGroup = Loadable(lazy(() => import('../views/ui/BtnGroup')));
const Collapse = Loadable(lazy(() => import('../views/ui/Collapse')));
const ListGroup = Loadable(lazy(() => import('../views/ui/ListGroup')));
const Modal = Loadable(lazy(() => import('../views/ui/Modal')));
const Navbar = Loadable(lazy(() => import('../views/ui/Navbar')));
const Nav = Loadable(lazy(() => import('../views/ui/Nav')));
const Pagination = Loadable(lazy(() => import('../views/ui/Pagination')));
const Popover = Loadable(lazy(() => import('../views/ui/Popover')));
const Progress = Loadable(lazy(() => import('../views/ui/Progress')));
const Spinner = Loadable(lazy(() => import('../views/ui/Spinner')));
const Tabs = Loadable(lazy(() => import('../views/ui/Tabs')));
const Toasts = Loadable(lazy(() => import('../views/ui/Toasts')));
const Tooltip = Loadable(lazy(() => import('../views/ui/Tooltip')));

/***** Form Layout Pages ****/
const FormBasic = Loadable(lazy(() => import('../views/form-layouts/FormBasic')));
const FormGrid = Loadable(lazy(() => import('../views/form-layouts/FormGrid')));
const FormGroup = Loadable(lazy(() => import('../views/form-layouts/FormGroup')));
const FormInput = Loadable(lazy(() => import('../views/form-layouts/FormInput')));

/***** Form Pickers Pages ****/
const Datepicker = Loadable(lazy(() => import('../views/form-pickers/DateTimePicker')));
const TagSelect = Loadable(lazy(() => import('../views/form-pickers/TagSelect')));

/***** Form Validation Pages ****/
const FormValidate = Loadable(lazy(() => import('../views/form-validation/FormValidation')));
const FormSteps = Loadable(lazy(() => import('../views/form-steps/Steps')));
const FormEditor = Loadable(lazy(() => import('../views/form-editor/FormEditor')));
/***** Table Pages ****/
const Basictable = Loadable(lazy(() => import('../views/tables/TableBasic')));
const CustomReactTable = Loadable(lazy(() => import('../views/tables/CustomReactTable')));
const ReactBootstrapTable = Loadable(lazy(() => import('../views/tables/ReactBootstrapTable')));

/***** Chart Pages ****/
const ApexCharts = Loadable(lazy(() => import('../views/charts/ApexCharts')));
const ChartJs = Loadable(lazy(() => import('../views/charts/ChartJs')));

/***** Sample Pages ****/
const StarterKit = Loadable(lazy(() => import('../views/sample-pages/StarterKit')));
const Profile = Loadable(lazy(() => import('../views/sample-pages/Profile')));
const Gallery = Loadable(lazy(() => import('../views/sample-pages/Gallery')));
const SearchResult = Loadable(lazy(() => import('../views/sample-pages/SearchResult')));
const HelperClass = Loadable(lazy(() => import('../views/sample-pages/HelperClass')));

/***** Icon Pages ****/
const Bootstrap = Loadable(lazy(() => import('../views/icons/Bootstrap')));
const Feather = Loadable(lazy(() => import('../views/icons/Feather')));

/***** Map Pages ****/
const CustomVectorMap = Loadable(lazy(() => import('../views/maps/CustomVectorMap')));

/***** Widget Pages ****/
const Widget = Loadable(lazy(() => import('../views/widget/Widget')));

/***** CASL Access Control ****/
const CASL = Loadable(lazy(() => import('../views/apps/accessControlCASL/AccessControl')));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')));
const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')));
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')));
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));
const ResetPassword = Loadable(lazy(() => import('../views/auth/ResetPwd')));
const ClusterId = Loadable(lazy(() => import('../views/auth/ClusterId')));

/***** Colleges *****/
const Colleges = Loadable(lazy(() => import('../views/dashboards/Colleges')));
const CreateCollege = Loadable(lazy(() => import('../views/dashboards/CreateCollege')));
const UpdateCollege = Loadable(lazy(() => import('../views/dashboards/UpdateCollege')));

/*****Routes******/

const environment = localStorage.getItem('environment') ?? 'prod'; // Change this to 'qa' or 'future' as needed

const ThemeRoutes = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', name: 'Home', element: <Navigate to={`/${environment}/dashboards/minimal`} /> },
      {
        path: `/${environment}/dashboards/minimal`,
        name: 'Minimal',
        exact: true,
        element: <Minimal />,
      },
      { path: `/${environment}/dashboards/users`, name: 'Users', exact: true, element: <Users /> },
      {
        path: `/${environment}/dashboards/Company`,
        name: 'Company',
        exact: true,
        element: <Company />,
      },
      { path: `/${environment}/dashboards/Admin`, name: 'Admin', exact: true, element: <Admin /> },
      {
        path: `/${environment}/dashboards/cluster`,
        name: 'Cluster',
        exact: true,
        element: <Cluster />,
      },
      {
        path: `/${environment}/dashboards/colleges`,
        name: 'Colleges',
        exact: true,
        element: <Colleges />,
      },
      {
        path: `/${environment}/dashboards/colleges/create`,
        name: 'CreateCollege',
        exact: true,
        element: <CreateCollege />,
      },
      {
        path: `/${environment}/dashboards/colleges/update/:id`,
        name: 'UpdateCollege',
        exact: true,
        element: <UpdateCollege />,
      },
      { path: `/${environment}/dashboards/team`, name: 'Team', exact: true, element: <Team /> },
      {
        path: `/${environment}/dashboards/analytical`,
        name: 'Analytical',
        exact: true,
        element: <Analytical />,
      },
      {
        path: `/${environment}/dashboards/issuecredits`,
        name: 'IssueCredits',
        exact: true,
        element: <IssueCredits />,
      },
      { path: `/${environment}/dashboards/group`, name: 'Group', exact: true, element: <Group /> },
      {
        path: `/${environment}/dashboards/Events`,
        name: 'Events',
        exact: true,
        element: <Events />,
      },
      {
        path: `/${environment}/dashboards/creategroup`,
        name: 'CreateGroup',
        exact: true,
        element: <CreateGroup />,
      },
      {
        path: `/${environment}/dashboards/createbanner`,
        name: 'CreateBanner',
        exact: true,
        element: <CreateBanner />,
      },
      {
        path: `/${environment}/dashboards/updatebanner/:id`,
        name: 'UpdateBanner',
        exact: true,
        element: <UpdateBanner />,
      },
      {
        path: `/${environment}/dashboards/createcoupon`,
        name: 'CreateCoupon',
        exact: true,
        element: <CreateCoupon />,
      },

      {
        path: `/${environment}/blogs/list`,
        name: 'NewBlogs',
        exact: true,
        element: <NewBlogs />,
      },
      {
        path: `/${environment}/blogs/create`,
        name: 'NewCreateBlog',
        exact: true,
        element: <NewCreateBlog />,
      },
      {
        path: `/${environment}/blogs/update/:id`,
        name: 'NewUpdateBlog',
        exact: true,
        element: <NewUpdateBlog />,
      },
      {
        path: `/${environment}/blogs/view/:id`,
        name: 'ViewBlog',
        exact: true,
        element: <ViewBlog />,
      },
      {
        path: `/${environment}/dashboards/blogs`,
        name: 'BlogsPage',
        exact: true,
        element: <Blogs />,
      },
      {
        path: `/${environment}/dashboards/blogs2`,
        name: 'BlogsPage2',
        exact: true,
        element: <Blogs2 />,
      },
      {
        path: `/${environment}/dashboards/createpromocode`,
        name: 'CreatePromoCode',
        exact: true,
        element: <CreatePromoCode />,
      },
      {
        path: `/${environment}/dashboards/feedback`,
        name: 'Feedback',
        exact: true,
        element: <Feedback />,
      },
      {
        path: `/${environment}/dashboards/job-posts`,
        name: 'JobPost',
        exact: true,
        element: <JobPost />,
      },
      {
        path: `/${environment}/dashboards/new-job-post`,
        name: 'NewJobPost',
        exact: true,
        element: <NewJobPost />,
      },
      {
        path: `/${environment}/dashboards/new-company`,
        name: 'NewCompany',
        exact: true,
        element: <NewCompany />,
      },
      {
        path: `/${environment}/dashboards/listing-companies`,
        name: 'ListingCompanies',
        exact: true,
        element: <ListingCompanies />,
      },
      {
        path: `/${environment}/dashboards/interview`,
        name: 'Interview',
        exact: true,
        element: <Interview />,
      },
      {
        path: `/${environment}/dashboards/editcluster`,
        name: 'EditCluster',
        exact: true,
        element: <EditCluster />,
      },
      {
        path: `/${environment}/dashboards/companyregister`,
        name: 'CompanyRegister',
        exact: true,
        element: <CompanyRegister />,
      },
      {
        path: `/${environment}/dashboards/Analytics_Report`,
        name: 'Analytics_Report',
        exact: true,
        element: <Analytics_Report />,
      },
      {
        path: `/${environment}/dashboards/Coupon_Code`,
        name: 'Coupon_Code',
        exact: true,
        element: <Coupon_Code />,
      },
      {
        path: `/${environment}/dashboards/Banners`,
        name: 'Banners',
        exact: true,
        element: <Banners />,
      },
      {
        path: `/${environment}/dashboards/demographical`,
        name: 'Demographical',
        exact: true,
        element: <Demographical />,
      },
      {
        path: `/${environment}/dashboards/modern`,
        name: 'Modern',
        exact: true,
        element: <Modern />,
      },
      { path: `/${environment}/apps/notes`, name: 'Notes', exact: true, element: <Notes /> },
      { path: `/${environment}/apps/chat`, name: 'Chat', exact: true, element: <Chat /> },
      {
        path: `/${environment}/apps/contacts`,
        name: 'Contacts',
        exact: true,
        element: <Contacts />,
      },
      {
        path: `/${environment}/apps/calendar`,
        name: 'Calendar',
        exact: true,
        element: <Calendar />,
      },
      { path: `/${environment}/apps/email`, name: 'Email', exact: true, element: <Email /> },
      { path: `/${environment}/ecom/shop`, name: 'Shop', exact: true, element: <Shop /> },
      {
        path: `/${environment}/ecom/shopdetail`,
        name: 'ShopDetail',
        exact: true,
        element: <ShopDetail />,
      },
      {
        path: `/${environment}/tickt/ticket-list`,
        name: 'TicketList',
        exact: true,
        element: <TicketList />,
      },
      {
        path: `/${environment}/tickt/ticket-detail`,
        name: 'TicketDetail',
        exact: true,
        element: <TicketDetail />,
      },
      {
        path: `/${environment}/apps/treeview`,
        name: 'Treeview',
        exact: true,
        element: <Treeview />,
      },
      { path: `/ui/alerts`, name: 'Alerts', exact: true, element: <Alerts /> },
      { path: `/ui/badges`, name: 'Badges', exact: true, element: <Badges /> },
      { path: `/ui/buttons`, name: 'Buttons', exact: true, element: <Buttons /> },
      { path: `/ui/cards`, name: 'Cards', exact: true, element: <Cards /> },
      { path: `/ui/grid`, name: 'Grid', exact: true, element: <Grid /> },
      { path: `/ui/table`, name: 'Tables', exact: true, element: <Tables /> },
      { path: `/ui/forms`, name: 'Forms', exact: true, element: <Forms /> },
      {
        path: `/ui/breadcrumbs`,
        name: 'Breadcrumbs',
        exact: true,
        element: <Breadcrumbs />,
      },
      {
        path: `/ui/dropdown`,
        name: 'Dropdowns',
        exact: true,
        element: <Dropdowns />,
      },
      {
        path: `/ui/button-group`,
        name: 'BtnGroup',
        exact: true,
        element: <BtnGroup />,
      },
      { path: `/ui/collapse`, name: 'Collapse', exact: true, element: <Collapse /> },
      {
        path: `/ui/list-group`,
        name: 'ListGroup',
        exact: true,
        element: <ListGroup />,
      },
      { path: `/ui/modal`, name: 'Modal', exact: true, element: <Modal /> },
      { path: `/ui/navbar`, name: 'Navbar', exact: true, element: <Navbar /> },
      { path: `/ui/nav`, name: 'Nav', exact: true, element: <Nav /> },
      {
        path: `/ui/pagination`,
        name: 'Pagination',
        exact: true,
        element: <Pagination />,
      },
      { path: `/ui/popover`, name: 'Popover', exact: true, element: <Popover /> },
      { path: `/ui/progress`, name: 'Progress', exact: true, element: <Progress /> },
      { path: `/ui/spinner`, name: 'Spinner', exact: true, element: <Spinner /> },
      { path: `/ui/tabs`, name: 'Tabs', exact: true, element: <Tabs /> },
      { path: `/ui/toasts`, name: 'Toasts', exact: true, element: <Toasts /> },
      { path: `/ui/tooltip`, name: 'Tooltip', exact: true, element: <Tooltip /> },
      {
        path: `/form-layout/form-basic`,
        name: 'FormBasic',
        exact: true,
        element: <FormBasic />,
      },
      {
        path: `/form-layout/form-grid`,
        name: 'FormGrid',
        exact: true,
        element: <FormGrid />,
      },
      {
        path: `/form-layout/form-group`,
        name: 'FormGroup',
        exact: true,
        element: <FormGroup />,
      },
      {
        path: `/form-layout/form-input`,
        name: 'FormInput',
        exact: true,
        element: <FormInput />,
      },
      {
        path: `/form-pickers/datepicker`,
        name: 'Datepicker',
        exact: true,
        element: <Datepicker />,
      },
      {
        path: `/form-pickers/tag-select`,
        name: 'TagSelect',
        exact: true,
        element: <TagSelect />,
      },
      {
        path: `/${environment}/form-validation`,
        name: 'FormValidate',
        exact: true,
        element: <FormValidate />,
      },
      {
        path: `/form-steps`,
        name: 'FormSteps',
        exact: true,
        element: <FormSteps />,
      },
      {
        path: `/form-editor`,
        name: 'FormEditor',
        exact: true,
        element: <FormEditor />,
      },
      {
        path: `/tables/basic-table`,
        name: 'Basictable',
        exact: true,
        element: <Basictable />,
      },
      {
        path: `/tables/react-table`,
        name: 'CustomReactTable',
        exact: true,
        element: <CustomReactTable />,
      },
      {
        path: `/tables/data-table`,
        name: 'ReactBootstrapTable',
        exact: true,
        element: <ReactBootstrapTable />,
      },
      {
        path: `/charts/apex`,
        name: 'ApexCharts',
        exact: true,
        element: <ApexCharts />,
      },
      {
        path: `/charts/chartjs`,
        name: 'ChartJs',
        exact: true,
        element: <ChartJs />,
      },
      {
        path: `/sample-pages/profile`,
        name: 'Profile',
        exact: true,
        element: <Profile />,
      },
      {
        path: `/sample-pages/helper-class`,
        name: 'HelperClass',
        exact: true,
        element: <HelperClass />,
      },
      {
        path: `/sample-pages/starterkit`,
        name: 'StarterKit',
        exact: true,
        element: <StarterKit />,
      },
      {
        path: `/sample-pages/gallery`,
        name: 'Gallery',
        exact: true,
        element: <Gallery />,
      },
      {
        path: `/sample-pages/search-result`,
        name: 'SearchResult',
        exact: true,
        element: <SearchResult />,
      },
      {
        path: `/icons/bootstrap`,
        name: 'Bootstrap',
        exact: true,
        element: <Bootstrap />,
      },
      { path: `/icons/feather`, name: 'Feather', exact: true, element: <Feather /> },
      {
        path: `/map/vector`,
        name: 'CustomVectorMap',
        exact: true,
        element: <CustomVectorMap />,
      },
      { path: `/widget`, name: 'Widget', exact: true, element: <Widget /> },
      { path: `/casl`, name: 'CASL', exact: true, element: <CASL /> },
      { path: '*', element: <Navigate to={`/${environment}/auth/404`} /> },
    ],
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to={`/${environment}/auth/404`} /> },
      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'loginformik', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'recoverpwd', element: <RecoverPassword /> },
    ],
  },
  { path: `/${environment}/registerformik/:id`, element: <RegisterFormik /> },
  { path: `/${environment}/reset-password/:token`, element: <ResetPassword /> },
  // {
  //   path: `/${environment}/auth`,
  //   element: <BlankLayout />,
  //   children: [
  //     { path: '404', element: <Error /> },
  //     { path: '*', element: <Navigate to={`/${environment}/auth/404`} /> },
  //     { path: 'registerformik', element: <RegisterFormik /> },
  //     { path: 'loginformik', element: <LoginFormik /> },
  //     { path: 'maintanance', element: <Maintanance /> },
  //     { path: 'lockscreen', element: <LockScreen /> },
  //     { path: 'recoverpwd', element: <RecoverPassword /> },
  //     { path: 'clusterid', element: <ClusterId /> },
  //   ],
  // },
  { path: `/${environment}/auth/404`, element: <Error /> },
  { path: `/${environment}/auth/registerformik`, element: <RegisterFormik /> },
  { path: `/${environment}/auth/loginformik`, element: <LoginFormik /> },
  { path: `/${environment}/auth/maintanance`, element: <Maintanance /> },
  { path: `/${environment}/auth/lockscreen`, element: <LockScreen /> },
  { path: `/${environment}/auth/recoverpwd`, element: <RecoverPassword /> },
  { path: `/${environment}/auth/reset-password/:token`, element: <ResetPassword /> },
  { path: `/${environment}/auth/clusterid`, element: <ClusterId /> },
];

export default ThemeRoutes;
